/**
 * My API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { AdjustRecordLetterState } from './adjust-record-letter-state';

export interface UpdateManyRecordStatesPartner {
  state?: UpdateManyRecordStatesPartnerStateEnum | null;
  processState?: UpdateManyRecordStatesPartnerProcessStateEnum | null;
  recordLetterState?: AdjustRecordLetterState;
  recordIds?: Array<string> | null;
}
export enum UpdateManyRecordStatesPartnerStateEnum {
  Active = 'Active',
  Draft = 'Draft',
  Outdated = 'Outdated',
  Irrelevant = 'Irrelevant'
}
export enum UpdateManyRecordStatesPartnerProcessStateEnum {
  None = 'None',
  Open = 'Open',
  TafCreated = 'TafCreated',
  TafPublished = 'TafPublished',
  ReadyForCalculation = 'ReadyForCalculation',
  Calculated = 'Calculated',
  Frozen = 'Frozen',
  AchievementLetterCreated = 'AchievementLetterCreated',
  AchievementLetterPublished = 'AchievementLetterPublished'
}
